<script>
    import { fade } from 'svelte/transition';

// Components
import TextCard from './cards/TextCard.svelte';
import RegSmitteCard from "./cards/RegSmitteCard.svelte";
import GraphCard from './cards/GraphCard.svelte';

// logic
import {allKommunesData, msisData, susStore} from '../utils/apiStore';
import {numberWithSpaces} from '../utils/utils';
import { onMount } from 'svelte';

// Bindings
export let title = undefined;
let msis = undefined;
let dodeTotalt = '-';
let antallChart1 = 60;
const nordjaerenKommuner = ["Stavanger", "Sandnes", "Randaberg", "Sola"];
let nordjaerenTotal = '-';
$: susAll = [];
$: susLast = {}

onMount(async ()=>{
    susStore.subscribe(value => {
        if( value != undefined) {
            dodeTotalt = value.last.deaths;
            susAll = value.all;
            susLast = value.last;
        }
    })

    allKommunesData.subscribe(value => {
        if(value != undefined) {
            let total = 0;
            value.map( el => {
                if(nordjaerenKommuner.includes(el.name)) {
                    total += el.newCases                    
                }
            })
            nordjaerenTotal = total;
        }
    }); 

    msisData.subscribe(value => {
        if(value != undefined) {
            msis = value;
        }
    });
})


$: dode = [
    {
        label: "totalt",
        value: dodeTotalt
    }
]

$: nordjaeren = [
        {
            label: "nye i går",
            value: nordjaerenTotal
        }
    ]

</script>

        {#if title != undefined}
            <h1 class="page-content__title">{title}</h1>
        {/if}
        <!-- <div in:fade class="page-content wide disclaimer">
            <p class="page-content__ingress">Norsk helsenett hadde driftsproblemer 23. november, noe som førte til at det ble registrert et uvanlig lavt antall tilfeller denne dagen. Tilfellene som manglet ble etterregistrert den 24. november.</p>
        </div> -->
        <div in:fade class="rogaland">
            <div class="card-container">
                {#if msis != undefined}
                    <RegSmitteCard title="Registrert smitte" subtitle="Hva viser grafen?" poptext={"Den røde linjen viser snittet de siste 7 dager. Søylene viser antall tilfeller pr dag."} antallChart1={antallChart1} p2={numberWithSpaces(msis.total)} switchgraph={true} chartData={msis.all.slice(-antallChart1)} chartData2={msis.all}></RegSmitteCard>
                {/if}
            </div>
            <div class="container">
                <div class="columns ">
        
                  <!-- <div class="column col-3 col-sm-6">
                      <TextCard title="Nord-Jæren" subtitle="Smittetall for Stavanger, Sandnes, Randaberg og Sola" textArray={nordjaeren}></TextCard>
                    </div> -->
                <!-- <div class="column col-3 col-sm-6">
                    <TextCard title="Døde" subtitle="Dødsfall meldt av SUS" textArray={dode}></TextCard>
                  </div> -->
                <div class="column col-6">
                    <GraphCard title="Innlagte på SUS" subtitle="" {susAll} {susLast}></GraphCard>
                  </div>
                
                
                </div>
              </div>
        </div>


<style lang="scss">
.rogaland {
    margin-top: .6rem;
}

.column {
    min-height: 120px;
}
</style>
